import { useConfirmChangingPassword } from 'hooks/api/changePassword';
import { Modal, ModalProps } from 'components/Modal';
import CodeVerification from 'components/CodeVerification';
import VerifyResendCode from 'components/VerifyResendCode';
import Loader from 'components/Loader';
import messages from './VerifyChangingPasswordModal.messages';
import styles from './VerifyChangingPasswordModal.module.css';

type Props = {
  onRequestClose: VoidFunction;
  onResendCode: () => Promise<void>;
  newPassword: string;
  phoneLastFourDigits: string;
} & ModalProps;

const VerifyChangingPasswordModal = ({
  onRequestClose,
  newPassword,
  phoneLastFourDigits,
  onResendCode,
  ...props
}: Props): JSX.Element => {
  const {
    mutateAsync: confirmChangingPassword,
    isLoading,
    isError,
  } = useConfirmChangingPassword();

  const confirm = async (code: string) => {
    await confirmChangingPassword({ code, newPassword });
    onRequestClose();
  };

  return (
    <Modal
      {...props}
      onRequestClose={onRequestClose}
      className={styles.verifyChangingPasswordModal}
      disabled={isLoading}
    >
      <h3 className={styles.verifyChangingPasswordModal__title}>{messages.title}</h3>
      <p className={styles.verifyChangingPasswordModal__subtitle}>
        {messages.subtitle}
        <span className={styles.verifyChangingPasswordModal__phone}>
          {phoneLastFourDigits}
        </span>
      </p>
      <div className={styles.verifyChangingPasswordModal__code}>
        <CodeVerification
          codeLength={4}
          onChange={confirm}
          loading={isLoading}
          isError={isError}
        />
      </div>
      <div className={styles.verifyChangingPasswordModal__loaderWrapper}>
        {isLoading && <Loader className={styles.verifyChangingPasswordModal__loader} />}
      </div>
      <VerifyResendCode resendCode={onResendCode} />
    </Modal>
  );
};

export default VerifyChangingPasswordModal;
